<script>
  import _ from 'underscore'
  import ItemPage from '../components/ItemPage.vue'
  import ItemList from '../components/ItemList.vue'
  import PageChooser from '../components/PageChooser.vue'
  import Status from '../components/Status.vue'
  import { item } from '../components/Item.vue'

  export default {
    components: { ItemPage, ItemList, PageChooser, Status },

    data () {
      return {
        date : '2021-01-07',
        major: [
          '10月チャンネル',
          '11月チャンネル',
          '共通',
        ],
        excepts: [
        ],
        items: [

          // [NOTE] KR
          // ================================================================================

          item({
            collection  : '10月チャンネル',
            id          : 'PCH4-01',
            rare        : 'KR',
            name        : 'ユニバースクイーンキラッとワンピ',
            imgUrl      : '/images/items/PCH4-01.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : 'UQ',
            type        : 'CO',
            point       : 1900,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '10月チャンネル',
            id          : 'PCH4-02',
            rare        : 'KR',
            name        : 'ユニバースクイーンキラッとシューズ',
            imgUrl      : '/images/items/PCH4-02.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'UQ',
            type        : 'CO',
            point       : 900,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '10月チャンネル',
            id          : 'PCH4-03',
            rare        : 'KR',
            name        : 'ユニバースクイーンキラッとヘアアクセ',
            imgUrl      : '/images/items/PCH4-03.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'UQ',
            type        : 'CO',
            point       : 900,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '10月チャンネル',
            rare        : 'KR',
          }),


          item({
            collection  : '11月チャンネル',
            id          : 'PCH4-62',
            rare        : 'KR',
            name        : 'ミラクル☆キラッツグループキラッとワンピ',
            imgUrl      : '/images/items/PCH4-62.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : '1900',
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '11月チャンネル',
            id          : 'PCH4-63',
            rare        : 'KR',
            name        : 'ミラクル☆キラッツグループキラッとシューズ',
            imgUrl      : '/images/items/PCH4-63.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : '900',
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '11月チャンネル',
            id          : 'PCH4-64',
            rare        : 'KR',
            name        : 'ミラクル☆キラッツグループキラッとヘアアクセ',
            imgUrl      : '/images/items/PCH4-64.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : '900',
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '11月チャンネル',
            rare        : 'KR',
          }),


          item({
            collection  : '11月チャンネル',
            id          : 'P-028',
            rare        : 'KR',
            name        : 'ポップミラクル☆キラッツグループキラッとワンピ',
            imgUrl      : '/images/items/P-028.png',
            kind        : 'ワンピース',
            color       : '水',
            brand       : 'GY',
            type        : 'PO',
            point       : '1900',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '11月チャンネル',
            id          : 'P-029',
            rare        : 'KR',
            name        : 'ポップミラクル☆キラッツグループキラッとシューズ',
            imgUrl      : '/images/items/P-029.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'GY',
            type        : 'PO',
            point       : '900',
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '11月チャンネル',
            id          : 'P-030',
            rare        : 'KR',
            name        : 'ポップミラクル☆キラッツグループキラッとヘアアクセ',
            imgUrl      : '/images/items/P-030.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'GY',
            type        : 'PO',
            point       : '900',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '11月チャンネル',
            rare        : 'KR',
          }),


          // [NOTE] PR
          // ================================================================================

          item({
            collection  : '10月チャンネル',
            id          : 'PCH4-04',
            rare        : 'PR',
            name        : 'ファンキーファーレッドトップス',
            imgUrl      : '/images/items/PCH4-04.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'UQ',
            type        : 'CO',
            point       : 850,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '10月チャンネル',
            id          : 'PCH4-05',
            rare        : 'PR',
            name        : 'ファンキーファーレッドスカート',
            imgUrl      : '/images/items/PCH4-05.png',
            kind        : 'スカート',
            color       : '赤',
            brand       : 'UQ',
            type        : 'CO',
            point       : 800,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '10月チャンネル',
            id          : 'PCH4-06',
            rare        : 'PR',
            name        : 'ファンキーファーレッドパープルシューズ',
            imgUrl      : '/images/items/PCH4-06.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'UQ',
            type        : 'CO',
            point       : 750,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '10月チャンネル',
            id          : 'PCH4-07',
            rare        : 'PR',
            name        : 'ファンキーファーレッドヘアアクセ',
            imgUrl      : '/images/items/PCH4-07.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'UQ',
            type        : 'CO',
            point       : 750,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '10月チャンネル',
            id          : 'PCH4-08',
            rare        : 'PR',
            name        : 'ファンキーファーシルバートップス',
            imgUrl      : '/images/items/PCH4-08.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'UQ',
            type        : 'CO',
            point       : 800,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '10月チャンネル',
            id          : 'PCH4-09',
            rare        : 'PR',
            name        : 'ファンキーファーシルバーパンツ',
            imgUrl      : '/images/items/PCH4-09.png',
            kind        : 'スカート',
            color       : '銀',
            brand       : 'UQ',
            type        : 'CO',
            point       : 750,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '10月チャンネル',
            id          : 'PCH4-10',
            rare        : 'PR',
            name        : 'ファンキーファーシルバーレッドシューズ',
            imgUrl      : '/images/items/PCH4-10.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'UQ',
            type        : 'CO',
            point       : 850,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '10月チャンネル',
            id          : 'PCH4-11',
            rare        : 'PR',
            name        : 'ファンキーファーシルバーヘアアクセ',
            imgUrl      : '/images/items/PCH4-11.png',
            kind        : 'ヘアアクセ',
            color       : '銀',
            brand       : 'UQ',
            type        : 'CO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '11月チャンネル',
            id          : 'PCH4-65',
            rare        : 'PR',
            name        : 'ホイップいちごスイートトップス',
            imgUrl      : '/images/items/PCH4-65.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : '850',
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '11月チャンネル',
            id          : 'PCH4-66',
            rare        : 'PR',
            name        : 'ホイップいちごスイートスカート',
            imgUrl      : '/images/items/PCH4-66.png',
            kind        : 'スカート',
            color       : '赤',
            brand       : 'SH',
            type        : 'LO',
            point       : '800',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '11月チャンネル',
            id          : 'PCH4-67',
            rare        : 'PR',
            name        : 'ホイップいちごスイートシューズ',
            imgUrl      : '/images/items/PCH4-67.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : '750',
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '11月チャンネル',
            id          : 'PCH4-68',
            rare        : 'PR',
            name        : 'ホイップいちごスイートヘアアクセ',
            imgUrl      : '/images/items/PCH4-68.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : '750',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '11月チャンネル',
            id          : 'PCH4-69',
            rare        : 'PR',
            name        : 'ホイップいちごベリートップス',
            imgUrl      : '/images/items/PCH4-69.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : '750',
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '11月チャンネル',
            id          : 'PCH4-70',
            rare        : 'PR',
            name        : 'ホイップいちごベリースカート',
            imgUrl      : '/images/items/PCH4-70.png',
            kind        : 'スカート',
            color       : '紫',
            brand       : 'SH',
            type        : 'LO',
            point       : '850',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '11月チャンネル',
            id          : 'PCH4-71',
            rare        : 'PR',
            name        : 'ホイップいちごベリーシューズ',
            imgUrl      : '/images/items/PCH4-71.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : '800',
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '11月チャンネル',
            id          : 'PCH4-72',
            rare        : 'PR',
            name        : 'ホイップいちごベリーヘアアクセ',
            imgUrl      : '/images/items/PCH4-72.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : '750',
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] PR モーリーファンタジー限定
          // ================================================================================

          item({
            collection  : 'モーリーファンタジー限定',
            id          : 'MF-01',
            rare        : 'PR',
            name        : 'ハロウィンマジカルグリーントップス',
            imgUrl      : '/images/items/MF-01.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'SH',
            type        : 'LO',
            point       : 850,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: true,
          }),
          item({
            collection  : 'モーリーファンタジー限定',
            id          : 'MF-02',
            rare        : 'PR',
            name        : 'ハロウィンマジカルグリーンスカート',
            imgUrl      : '/images/items/MF-02.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'SH',
            type        : 'LO',
            point       : 800,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: true,
          }),
          item({
            collection  : 'モーリーファンタジー限定',
            id          : 'MF-03',
            rare        : 'PR',
            name        : 'ハロウィンマジカルグリーンシューズ',
            imgUrl      : '/images/items/MF-03.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : 'SH',
            type        : 'LO',
            point       : 850,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: true,
          }),
          item({
            collection  : 'モーリーファンタジー限定',
            id          : 'MF-04',
            rare        : 'PR',
            name        : 'ハロウィンマジカルグリーンヘアアクセ',
            imgUrl      : '/images/items/MF-04.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'SH',
            type        : 'LO',
            point       : 750,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: true,
          }),


          // [NOTE] SR
          // ================================================================================

          item({
            collection  : '10月チャンネル',
            id          : 'PCH4-12',
            rare        : 'SR',
            name        : 'ねこうらないしビビッドワンピ',
            imgUrl      : '/images/items/PCH4-12.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : 'UQ',
            type        : 'CO',
            point       : 1200,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '10月チャンネル',
            id          : 'PCH4-13',
            rare        : 'SR',
            name        : 'ねこうらないしビビッドシューズ',
            imgUrl      : '/images/items/PCH4-13.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'UQ',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '10月チャンネル',
            id          : 'PCH4-14',
            rare        : 'SR',
            name        : 'ねこうらないしビビッドヘアアクセ',
            imgUrl      : '/images/items/PCH4-14.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'UQ',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '10月チャンネル',
            rare        : 'SR',
          }),


          item({
            collection  : '11月チャンネル',
            id          : 'PCH4-73',
            rare        : 'SR',
            name        : 'ホイップいちごソーダトップス',
            imgUrl      : '/images/items/PCH4-73.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : '700',
            numOwned    : { usual: 9 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '11月チャンネル',
            id          : 'PCH4-74',
            rare        : 'SR',
            name        : 'ホイップいちごソーダスカート',
            imgUrl      : '/images/items/PCH4-74.png',
            kind        : 'スカート',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : '650',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '11月チャンネル',
            id          : 'PCH4-75',
            rare        : 'SR',
            name        : 'ホイップいちごソーダシューズ',
            imgUrl      : '/images/items/PCH4-75.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : '600',
            numOwned    : { usual: 11 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '11月チャンネル',
            id          : 'PCH4-76',
            rare        : 'SR',
            name        : 'ホイップいちごソーダヘアアクセ',
            imgUrl      : '/images/items/PCH4-76.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : '600',
            numOwned    : { usual: 11 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '11月チャンネル',
            id          : 'PCH4-77',
            rare        : 'SR',
            name        : 'キラキラフィーバーイエロートップス',
            imgUrl      : '/images/items/PCH4-77.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : 'UQ',
            type        : 'CO',
            point       : '600',
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '11月チャンネル',
            id          : 'PCH4-78',
            rare        : 'SR',
            name        : 'キラキラフィーバーイエロースカート',
            imgUrl      : '/images/items/PCH4-78.png',
            kind        : 'スカート',
            color       : '黄',
            brand       : 'UQ',
            type        : 'CO',
            point       : '650',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '11月チャンネル',
            id          : 'PCH4-79',
            rare        : 'SR',
            name        : 'キラキラフィーバーイエローシューズ',
            imgUrl      : '/images/items/PCH4-79.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'UQ',
            type        : 'CO',
            point       : '700',
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '11月チャンネル',
            id          : 'PCH4-80',
            rare        : 'SR',
            name        : 'キラキラフィーバーイエローヘアアクセ',
            imgUrl      : '/images/items/PCH4-80.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'UQ',
            type        : 'CO',
            point       : '600',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] R
          // ================================================================================

          item({
            collection  : '共通',
            id          : 'PCH4-16',
            rare        : 'R',
            name        : 'プリ☆チャンユニフォームパープルトップス',
            imgUrl      : '/images/items/PCH4-16.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'PS',
            type        : 'CO',
            point       : 550,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH4-17',
            rare        : 'R',
            name        : 'プリ☆チャンユニフォームパープルスカート',
            imgUrl      : '/images/items/PCH4-17.png',
            kind        : 'スカート',
            color       : '紫',
            brand       : 'PS',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 9 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH4-18',
            rare        : 'R',
            name        : 'プリ☆チャンユニフォームパープルシューズ',
            imgUrl      : '/images/items/PCH4-18.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'PS',
            type        : 'CO',
            point       : 450,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH4-19',
            rare        : 'R',
            name        : 'プリ☆チャンユニフォームパープルヘアアクセ',
            imgUrl      : '/images/items/PCH4-19.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'PS',
            type        : 'CO',
            point       : 450,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '共通',
            id          : 'PCH4-20',
            rare        : 'R',
            name        : 'カジュアルマリンスカジャン',
            imgUrl      : '/images/items/PCH4-20.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 450,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH4-21',
            rare        : 'R',
            name        : 'カジュアルマリンスカート',
            imgUrl      : '/images/items/PCH4-21.png',
            kind        : 'スカート',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 500,
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH4-22',
            rare        : 'R',
            name        : 'カジュアルマリンシューズ',
            imgUrl      : '/images/items/PCH4-22.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 550,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH4-23',
            rare        : 'R',
            name        : 'カジュアルマリンヘアアクセ',
            imgUrl      : '/images/items/PCH4-23.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 450,
            numOwned    : { usual: 6 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '共通',
            id          : 'PCH4-24',
            rare        : 'R',
            name        : 'レトロストライプブルートップス',
            imgUrl      : '/images/items/PCH4-24.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'DW',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH4-25',
            rare        : 'R',
            name        : 'レトロストライプブルースカート',
            imgUrl      : '/images/items/PCH4-25.png',
            kind        : 'スカート',
            color       : '水',
            brand       : 'DW',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH4-26',
            rare        : 'R',
            name        : 'レトロストライプブルーシューズ',
            imgUrl      : '/images/items/PCH4-26.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'DW',
            type        : 'LO',
            point       : 450,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH4-27',
            rare        : 'R',
            name        : 'レトロストライプブルーヘアアクセ',
            imgUrl      : '/images/items/PCH4-27.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'DW',
            type        : 'LO',
            point       : 450,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '共通',
            id          : 'PCH4-28',
            rare        : 'R',
            name        : 'ペイントパターンピンクトップス',
            imgUrl      : '/images/items/PCH4-28.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'RB',
            type        : 'CO',
            point       : 550,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH4-29',
            rare        : 'R',
            name        : 'ペイントパターンピンクスカート',
            imgUrl      : '/images/items/PCH4-29.png',
            kind        : 'スカート',
            color       : '桃',
            brand       : 'RB',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH4-30',
            rare        : 'R',
            name        : 'ペイントパターンピンクシューズ',
            imgUrl      : '/images/items/PCH4-30.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'RB',
            type        : 'CO',
            point       : 450,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH4-31',
            rare        : 'R',
            name        : 'ペイントパターンピンクヘアアクセ',
            imgUrl      : '/images/items/PCH4-31.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'RB',
            type        : 'CO',
            point       : 450,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '共通',
            id          : 'PCH4-32',
            rare        : 'R',
            name        : 'トゥインクルスターかただしトップス',
            imgUrl      : '/images/items/PCH4-32.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'UQ',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH4-33',
            rare        : 'R',
            name        : 'トゥインクルスタースカート',
            imgUrl      : '/images/items/PCH4-33.png',
            kind        : 'スカート',
            color       : '白',
            brand       : 'UQ',
            type        : 'CO',
            point       : 450,
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH4-34',
            rare        : 'R',
            name        : 'トゥインクルスターシューズ',
            imgUrl      : '/images/items/PCH4-34.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'UQ',
            type        : 'CO',
            point       : 550,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH4-35',
            rare        : 'R',
            name        : 'トゥインクルスターヘアアクセ',
            imgUrl      : '/images/items/PCH4-35.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'UQ',
            type        : 'CO',
            point       : 450,
            numOwned    : { usual: 11 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] N
          // ================================================================================

          item({
            collection  : '共通',
            id          : 'PCH4-36',
            rare        : 'N',
            name        : 'フラワーガールデニムトップス',
            imgUrl      : '/images/items/PCH4-36.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'SH',
            type        : 'LO',
            point       : 400,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH4-37',
            rare        : 'N',
            name        : 'フラワーガールピンクスカート',
            imgUrl      : '/images/items/PCH4-37.png',
            kind        : 'スカート',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 350,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH4-38',
            rare        : 'N',
            name        : 'フラワーガールピンクシューズ',
            imgUrl      : '/images/items/PCH4-38.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 300,
            numOwned    : { usual: 4 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH4-39',
            rare        : 'N',
            name        : 'フラワーガールピンクヘアアクセ',
            imgUrl      : '/images/items/PCH4-39.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 300,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '共通',
            id          : 'PCH4-40',
            rare        : 'N',
            name        : 'ミステリーレッドトップス',
            imgUrl      : '/images/items/PCH4-40.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : 350,
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH4-41',
            rare        : 'N',
            name        : 'ミステリーレッドスカート',
            imgUrl      : '/images/items/PCH4-41.png',
            kind        : 'スカート',
            color       : '黒',
            brand       : 'SA',
            type        : 'CO',
            point       : 300,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH4-42',
            rare        : 'N',
            name        : 'ミステリーレッドシューズ',
            imgUrl      : '/images/items/PCH4-42.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'SA',
            type        : 'CO',
            point       : 400,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH4-43',
            rare        : 'N',
            name        : 'ミステリーレッドヘアアクセ',
            imgUrl      : '/images/items/PCH4-43.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : 300,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '共通',
            id          : 'PCH4-44',
            rare        : 'N',
            name        : 'ヴィンテージチェックワンピ',
            imgUrl      : '/images/items/PCH4-44.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : 'DW',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 8 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH4-45',
            rare        : 'N',
            name        : 'ヴィンテージチェックシューズ',
            imgUrl      : '/images/items/PCH4-45.png',
            kind        : 'シューズ',
            color       : '茶',
            brand       : 'DW',
            type        : 'LO',
            point       : 300,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH4-46',
            rare        : 'N',
            name        : 'ヴィンテージチェックヘアアクセ',
            imgUrl      : '/images/items/PCH4-46.png',
            kind        : 'ヘアアクセ',
            color       : '茶',
            brand       : 'DW',
            type        : 'LO',
            point       : 300,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            rare        : 'N',
          }),


          item({
            collection  : '共通',
            id          : 'PCH4-47',
            rare        : 'N',
            name        : 'マニッシュパンクトップス',
            imgUrl      : '/images/items/PCH4-47.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'RB',
            type        : 'CO',
            point       : 400,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH4-48',
            rare        : 'N',
            name        : 'マニッシュパンクスカート',
            imgUrl      : '/images/items/PCH4-48.png',
            kind        : 'スカート',
            color       : '白',
            brand       : 'RB',
            type        : 'CO',
            point       : 350,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH4-49',
            rare        : 'N',
            name        : 'マニッシュパンクシューズ',
            imgUrl      : '/images/items/PCH4-49.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'RB',
            type        : 'CO',
            point       : 300,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH4-50',
            rare        : 'N',
            name        : 'マニッシュパンクヘアアクセ',
            imgUrl      : '/images/items/PCH4-50.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'RB',
            type        : 'CO',
            point       : 300,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] パシャッとアイテム
          // ================================================================================

          item({
            collection  : '10月チャンネル',
            id          : 'PCH4-15',
            rare        : 'SR',
            name        : 'パープルフェザーせんす',
            imgUrl      : '/images/items/PCH4-15.png',
            kind        : 'パシャッとアイテム',
            color       : '紫',
            brand       : 'UQ',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '10月チャンネル',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : '10月チャンネル',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : '10月チャンネル',
            kind        : 'パシャッとアイテム',
          }),


          item({
            collection  : '11月チャンネル',
            id          : 'PCH4-81',
            rare        : 'SR',
            name        : 'ロリータピンクパラソル',
            imgUrl      : '/images/items/PCH4-81.png',
            kind        : 'パシャッとアイテム',
            color       : '桃',
            brand       : 'DW',
            type        : 'LO',
            point       : '600',
            numOwned    : { usual: 9 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '11月チャンネル',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : '11月チャンネル',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : '11月チャンネル',
            kind        : 'パシャッとアイテム',
          }),


          item({
            collection  : '共通',
            id          : 'PCH4-51',
            rare        : 'R',
            name        : 'ヴィンテージブラウンブック',
            imgUrl      : '/images/items/PCH4-51.png',
            kind        : 'パシャッとアイテム',
            color       : '茶',
            brand       : 'DW',
            type        : 'LO',
            point       : 450,
            numOwned    : { usual: 10 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH4-52',
            rare        : 'R',
            name        : 'まほうのピンクカード',
            imgUrl      : '/images/items/PCH4-52.png',
            kind        : 'パシャッとアイテム',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 450,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : '共通',
            kind        : 'パシャッとアイテム',
          }),


          // [NOTE] なかよしチャンネル
          // ================================================================================

          item({
            collection  : 'なかよしチャンネル',
            id          : 'PCH4-95',
            rare        : 'SR',
            name        : 'レッドフェザーせんす',
            imgUrl      : '/images/items/PCH4-95.png',
            kind        : 'パシャッとアイテム',
            color       : '赤',
            brand       : 'UQ',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'なかよしチャンネル',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : 'なかよしチャンネル',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : 'なかよしチャンネル',
            kind        : 'パシャッとアイテム',
          }),



          // [NOTE] ブランドチャンネル
          // ================================================================================

          item({
            collection  : 'Dolly Waltz チャンネル',
            id          : 'DW-08',
            rare        : 'SR',
            name        : 'レトロストライプピンクトップス',
            imgUrl      : '/images/items/DW-08.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'DW',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Dolly Waltz チャンネル',
            id          : 'DW-09',
            rare        : 'SR',
            name        : 'レトロストライプピンクスカート',
            imgUrl      : '/images/items/DW-09.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'DW',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Dolly Waltz チャンネル',
            id          : 'DW-10',
            rare        : 'SR',
            name        : 'レトロストライプピンクシューズ',
            imgUrl      : '/images/items/DW-10.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'DW',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Dolly Waltz チャンネル',
            id          : 'DW-11',
            rare        : 'SR',
            name        : 'レトロストライプピンクヘアアクセ',
            imgUrl      : '/images/items/DW-11.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'DW',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'Romance Beat チャンネル',
            id          : 'RB-09',
            rare        : 'SR',
            name        : 'ペイントパターンブルートップス',
            imgUrl      : '/images/items/RB-09.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'RB',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Romance Beat チャンネル',
            id          : 'RB-10',
            rare        : 'SR',
            name        : 'ペイントパターンブルースカート',
            imgUrl      : '/images/items/RB-10.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'RB',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Romance Beat チャンネル',
            id          : 'RB-11',
            rare        : 'SR',
            name        : 'ペイントパターンブルーシューズ',
            imgUrl      : '/images/items/RB-11.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'RB',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Romance Beat チャンネル',
            id          : 'RB-12',
            rare        : 'SR',
            name        : 'ペイントパターンブルーヘアアクセ',
            imgUrl      : '/images/items/RB-12.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'RB',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'Universe Queen チャンネル',
            id          : 'UQ-01',
            rare        : 'SR',
            name        : 'ねこうらないしフレッシュワンピ',
            imgUrl      : '/images/items/UQ-01.png',
            kind        : 'ワンピース',
            color       : '緑',
            brand       : 'UQ',
            type        : 'CO',
            point       : 1200,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Universe Queen チャンネル',
            id          : 'UQ-02',
            rare        : 'SR',
            name        : 'ねこうらないしフレッシュシューズ',
            imgUrl      : '/images/items/UQ-02.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'UQ',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Universe Queen チャンネル',
            id          : 'UQ-03',
            rare        : 'SR',
            name        : 'ねこうらないしフレッシュヘアアクセ',
            imgUrl      : '/images/items/UQ-03.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'UQ',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Universe Queen チャンネル',
            rare        : 'SR',
          }),


          item({
            collection  : 'Universe Queen チャンネル',
            id          : 'UQ-04',
            rare        : 'SR',
            name        : 'キラキラフィーバーピンクトップス',
            imgUrl      : '/images/items/UQ-04.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'UQ',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Universe Queen チャンネル',
            id          : 'UQ-05',
            rare        : 'SR',
            name        : 'キラキラフィーバーピンクスカート',
            imgUrl      : '/images/items/UQ-05.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'UQ',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Universe Queen チャンネル',
            id          : 'UQ-06',
            rare        : 'SR',
            name        : 'キラキラフィーバーピンクシューズ',
            imgUrl      : '/images/items/UQ-06.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'UQ',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Universe Queen チャンネル',
            id          : 'UQ-07',
            rare        : 'SR',
            name        : 'キラキラフィーバーピンクヘアアクセ',
            imgUrl      : '/images/items/UQ-07.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'UQ',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] ハロウィンコーデキャンペーン
          // ================================================================================

          item({
            collection  : 'ハロウィンコーデキャンペーン',
            id          : 'PCH4-53',
            rare        : 'SR',
            name        : 'ハロウィンマジカルパンプキントップス',
            imgUrl      : '/images/items/PCH4-53.png',
            kind        : 'トップス',
            color       : '橙',
            brand       : 'SH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ハロウィンコーデキャンペーン',
            id          : 'PCH4-54',
            rare        : 'SR',
            name        : 'ハロウィンマジカルパンプキンスカート',
            imgUrl      : '/images/items/PCH4-54.png',
            kind        : 'ボトムス',
            color       : '橙',
            brand       : 'SH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ハロウィンコーデキャンペーン',
            id          : 'PCH4-55',
            rare        : 'SR',
            name        : 'ハロウィンマジカルパンプキンシューズ',
            imgUrl      : '/images/items/PCH4-55.png',
            kind        : 'シューズ',
            color       : '橙',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ハロウィンコーデキャンペーン',
            id          : 'PCH4-56',
            rare        : 'SR',
            name        : 'ハロウィンマジカルパンプキンヘアアクセ',
            imgUrl      : '/images/items/PCH4-56.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'ハロウィンコーデキャンペーン',
            id          : 'PCH4-57',
            rare        : 'SR',
            name        : 'ハロウィンマジカルあかずきんトップス',
            imgUrl      : '/images/items/PCH4-57.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ハロウィンコーデキャンペーン',
            id          : 'PCH4-58',
            rare        : 'SR',
            name        : 'ハロウィンマジカルあかずきんスカート',
            imgUrl      : '/images/items/PCH4-58.png',
            kind        : 'ボトムス',
            color       : '黄',
            brand       : 'SH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ハロウィンコーデキャンペーン',
            id          : 'PCH4-59',
            rare        : 'SR',
            name        : 'ハロウィンマジカルあかずきんシューズ',
            imgUrl      : '/images/items/PCH4-59.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : 'SH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ハロウィンコーデキャンペーン',
            id          : 'PCH4-60',
            rare        : 'SR',
            name        : 'ハロウィンマジカルあかずきんヘアアクセ',
            imgUrl      : '/images/items/PCH4-60.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'ハロウィンコーデキャンペーン',
            id          : 'PCH4-61',
            rare        : 'SR',
            name        : 'ハロウィンマジカルバッグ',
            imgUrl      : '/images/items/PCH4-61.png',
            kind        : 'パシャッとアイテム',
            color       : '橙',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ハロウィンコーデキャンペーン',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : 'ハロウィンコーデキャンペーン',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : 'ハロウィンコーデキャンペーン',
            kind        : 'パシャッとアイテム',
          }),


          // [NOTE] シャイニーフレンズスペシャル大会
          // ================================================================================

          item({
            collection  : 'シャイニーフレンズスペシャル大会',
            id          : 'SP-009',
            rare        : 'SR',
            name        : 'ファンキーファーゴールドトップス',
            imgUrl      : '/images/items/SP-009.png',
            kind        : 'トップス',
            color       : '色',
            brand       : 'UQ',
            type        : 'CO',
            point       : '800',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'シャイニーフレンズスペシャル大会',
            id          : 'SP-010',
            rare        : 'SR',
            name        : 'ファンキーファーゴールドスカート',
            imgUrl      : '/images/items/SP-010.png',
            kind        : 'ボトムス',
            color       : '色',
            brand       : 'UQ',
            type        : 'CO',
            point       : '750',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'シャイニーフレンズスペシャル大会',
            id          : 'SP-011',
            rare        : 'SR',
            name        : 'ファンキーファーゴールドブルーシューズ',
            imgUrl      : '/images/items/SP-011.png',
            kind        : 'シューズ',
            color       : '色',
            brand       : 'UQ',
            type        : 'CO',
            point       : '700',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'シャイニーフレンズスペシャル大会',
            id          : 'SP-012',
            rare        : 'SR',
            name        : 'ファンキーファーゴールドヘアアクセ',
            imgUrl      : '/images/items/SP-012.png',
            kind        : 'ヘアアクセ',
            color       : '色',
            brand       : 'UQ',
            type        : 'CO',
            point       : '700',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] ミラクル☆キラッツセレクション
          // ================================================================================

          item({
            collection  : 'ミラクル☆キラッツセレクション',
            id          : 'SL4-01',
            rare        : 'PR',
            name        : 'ラビットハートミントトップス',
            imgUrl      : '/images/items/SL4-01.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : '',
            type        : 'LO',
            point       : 850,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ミラクル☆キラッツセレクション',
            id          : 'SL4-02',
            rare        : 'PR',
            name        : 'ラビットハートミントスカート',
            imgUrl      : '/images/items/SL4-02.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : '',
            type        : 'LO',
            point       : 800,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ミラクル☆キラッツセレクション',
            id          : 'SL4-03',
            rare        : 'PR',
            name        : 'ラビットハートミントシューズ',
            imgUrl      : '/images/items/SL4-03.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : '',
            type        : 'LO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ミラクル☆キラッツセレクション',
            id          : 'SL4-04',
            rare        : 'PR',
            name        : 'ラビットハートミントヘアアクセ',
            imgUrl      : '/images/items/SL4-04.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'ミラクル☆キラッツセレクション',
            id          : 'SL4-05',
            rare        : 'PR',
            name        : 'ムーンライトパープルトップス',
            imgUrl      : '/images/items/SL4-05.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ミラクル☆キラッツセレクション',
            id          : 'SL4-06',
            rare        : 'PR',
            name        : 'ムーンライトパープルパンツ',
            imgUrl      : '/images/items/SL4-06.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 850,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ミラクル☆キラッツセレクション',
            id          : 'SL4-07',
            rare        : 'PR',
            name        : 'ムーンライトパープルシューズ',
            imgUrl      : '/images/items/SL4-07.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'CO',
            point       : 800,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ミラクル☆キラッツセレクション',
            id          : 'SL4-08',
            rare        : 'PR',
            name        : 'ムーンライトパープルヘアアクセ',
            imgUrl      : '/images/items/SL4-08.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'ミラクル☆キラッツセレクション',
            id          : 'SL4-09',
            rare        : 'SR',
            name        : 'あおぞらマーチトップス',
            imgUrl      : '/images/items/PAF02-100.png',
            kind        : 'トップス',
            color       : '水',
            brand       : '',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ミラクル☆キラッツセレクション',
            id          : 'SL4-10',
            rare        : 'SR',
            name        : 'あおぞらマーチスカート',
            imgUrl      : '/images/items/PAF02-101.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : '',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ミラクル☆キラッツセレクション',
            id          : 'SL4-11',
            rare        : 'SR',
            name        : 'あおぞらマーチシューズ',
            imgUrl      : '/images/items/PAF02-102.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : '',
            type        : 'PO',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ミラクル☆キラッツセレクション',
            id          : 'SL4-12',
            rare        : 'SR',
            name        : 'あおぞらマーチヘアアクセ',
            imgUrl      : '/images/items/PAF02-103.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : '',
            type        : 'PO',
            point       : 600,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'ミラクル☆キラッツセレクション',
            id          : 'SL4-13',
            rare        : 'SR',
            name        : 'バニーマジシャンロイヤルワンピ',
            imgUrl      : '/images/items/SL4-13.png',
            kind        : 'ワンピース',
            color       : '赤',
            brand       : '',
            type        : 'CO',
            point       : 1200,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ミラクル☆キラッツセレクション',
            id          : 'SL4-14',
            rare        : 'SR',
            name        : 'バニーマジシャンロイヤルシューズ',
            imgUrl      : '/images/items/SL4-14.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : '',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ミラクル☆キラッツセレクション',
            id          : 'SL4-15',
            rare        : 'SR',
            name        : 'ホワイトバニーヘアアクセ',
            imgUrl      : '/images/items/SL4-15.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : '',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ミラクル☆キラッツセレクション',
            rare        : 'SR',
          }),


          item({
            collection  : 'ミラクル☆キラッツセレクション',
            id          : 'SL4-16',
            rare        : 'R',
            name        : 'アイシングクッキーメルヘンワンピ',
            imgUrl      : '/images/items/SL4-16.png',
            kind        : 'ワンピース',
            color       : '茶',
            brand       : '',
            type        : 'LO',
            point       : 900,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ミラクル☆キラッツセレクション',
            id          : 'SL4-17',
            rare        : 'R',
            name        : 'アイシングクッキーメルヘンシューズ',
            imgUrl      : '/images/items/SL4-17.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 450,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ミラクル☆キラッツセレクション',
            id          : 'SL4-18',
            rare        : 'R',
            name        : 'アイシングクッキーヘアアクセ',
            imgUrl      : '/images/items/SL4-18.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 450,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ミラクル☆キラッツセレクション',
            rare        : 'R',
          }),


          item({
            collection  : 'ミラクル☆キラッツセレクション',
            id          : 'SL4-19',
            rare        : 'R',
            name        : 'プリパラナースほほえみのトップス',
            imgUrl      : '/images/items/SL4-19.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : '',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ミラクル☆キラッツセレクション',
            id          : 'SL4-20',
            rare        : 'R',
            name        : 'プリパラナースほほえみのスカート',
            imgUrl      : '/images/items/SL4-20.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : '',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ミラクル☆キラッツセレクション',
            id          : 'SL4-21',
            rare        : 'R',
            name        : 'プリパラナースほほえみのシューズ',
            imgUrl      : '/images/items/SL4-21.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : '',
            type        : 'LO',
            point       : 450,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ミラクル☆キラッツセレクション',
            id          : 'SL4-22',
            rare        : 'R',
            name        : 'プリパラナースほほえみのヘアアクセ',
            imgUrl      : '/images/items/SL4-22.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : 450,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'ミラクル☆キラッツセレクション',
            id          : 'SL4-23',
            rare        : 'R',
            name        : 'チアガールシャイントップス',
            imgUrl      : '/images/items/SL4-23.png',
            kind        : 'トップス',
            color       : '橙',
            brand       : '',
            type        : 'PO',
            point       : 500,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ミラクル☆キラッツセレクション',
            id          : 'SL4-24',
            rare        : 'R',
            name        : 'チアガールシャインスカート',
            imgUrl      : '/images/items/SL4-24.png',
            kind        : 'ボトムス',
            color       : '橙',
            brand       : '',
            type        : 'PO',
            point       : 550,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ミラクル☆キラッツセレクション',
            id          : 'SL4-25',
            rare        : 'R',
            name        : 'チアガールシャインシューズ',
            imgUrl      : '/images/items/SL4-25.png',
            kind        : 'シューズ',
            color       : '橙',
            brand       : '',
            type        : 'PO',
            point       : 450,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ミラクル☆キラッツセレクション',
            id          : 'SL4-26',
            rare        : 'R',
            name        : 'チアガールシャインヘアアクセ',
            imgUrl      : '/images/items/SL4-26.png',
            kind        : 'ヘアアクセ',
            color       : '橙',
            brand       : '',
            type        : 'PO',
            point       : 450,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'ミラクル☆キラッツセレクション',
            id          : 'SL4-27',
            rare        : 'R',
            name        : 'せいしゅんスクールれもんいろトップス',
            imgUrl      : '/images/items/SL4-27.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : '',
            type        : 'PO',
            point       : 550,
            numOwned    : { usual: 4 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ミラクル☆キラッツセレクション',
            id          : 'SL4-28',
            rare        : 'R',
            name        : 'せいしゅんスクールれもんいろスカート',
            imgUrl      : '/images/items/SL4-28.png',
            kind        : 'ボトムス',
            color       : '黄',
            brand       : '',
            type        : 'PO',
            point       : 450,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ミラクル☆キラッツセレクション',
            id          : 'SL4-29',
            rare        : 'R',
            name        : 'せいしゅんスクールれもんいろシューズ',
            imgUrl      : '/images/items/SL4-29.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : '',
            type        : 'PO',
            point       : 500,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ミラクル☆キラッツセレクション',
            id          : 'SL4-30',
            rare        : 'R',
            name        : 'せいしゅんスクールれもんいろヘアアクセ',
            imgUrl      : '/images/items/SL4-30.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : '',
            type        : 'PO',
            point       : 450,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'ミラクル☆キラッツセレクション',
            id          : 'SL4-31',
            rare        : 'R',
            name        : 'プリパラポリスレッツイゴートップス',
            imgUrl      : '/images/items/SL4-31.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 550,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ミラクル☆キラッツセレクション',
            id          : 'SL4-32',
            rare        : 'R',
            name        : 'プリパラポリスレッツイゴーパンツ',
            imgUrl      : '/images/items/SL4-32.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 3 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ミラクル☆キラッツセレクション',
            id          : 'SL4-33',
            rare        : 'R',
            name        : 'プリパラポリスレッツイゴーシューズ',
            imgUrl      : '/images/items/SL4-33.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 450,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ミラクル☆キラッツセレクション',
            id          : 'SL4-34',
            rare        : 'R',
            name        : 'プリパラポリスレッツイゴーヘアアクセ',
            imgUrl      : '/images/items/SL4-34.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 450,
            numOwned    : { usual: 3 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] すみっコぐらしチャンネル
          // ================================================================================

          item({
            collection  : 'すみっコぐらしチャンネル',
            id          : 'PCH4-83',
            rare        : 'R',
            name        : 'すみっコぐらしピンクワンピ',
            imgUrl      : '/images/items/PCH4-83.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 900,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すみっコぐらしチャンネル',
            id          : 'PCH4-84',
            rare        : 'R',
            name        : 'すみっコぐらしピンクシューズ',
            imgUrl      : '/images/items/PCH4-84.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 450,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すみっコぐらしチャンネル',
            id          : 'PCH4-85',
            rare        : 'R',
            name        : 'すみっコぐらしヘアアクセ',
            imgUrl      : '/images/items/PCH4-85.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 450,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すみっコぐらしチャンネル',
            rare        : 'R',
          }),


          item({
            collection  : 'すみっコぐらしチャンネル',
            id          : 'PCH4-86',
            rare        : 'R',
            name        : 'すみっコぐらしブルーワンピ',
            imgUrl      : '/images/items/PCH4-86.png',
            kind        : 'ワンピース',
            color       : '水',
            brand       : '',
            type        : 'PR',
            point       : 900,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すみっコぐらしチャンネル',
            id          : 'PCH4-87',
            rare        : 'R',
            name        : 'すみっコぐらしブルーシューズ',
            imgUrl      : '/images/items/PCH4-87.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : '',
            type        : 'PR',
            point       : 450,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すみっコぐらしチャンネル',
            id          : 'PCH4-88',
            rare        : 'R',
            name        : 'すみっコぐらしカチューシャ',
            imgUrl      : '/images/items/PCH4-88.png',
            kind        : 'ヘアアクセ',
            color       : '橙',
            brand       : '',
            type        : 'PR',
            point       : 450,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すみっコぐらしチャンネル',
            rare        : 'R',
          }),


          item({
            collection  : 'すみっコぐらしチャンネル',
            id          : 'PCH4-89',
            rare        : 'R',
            name        : 'すみっコぐらしにくきゅうトップス',
            imgUrl      : '/images/items/PCH4-89.png',
            kind        : 'トップス',
            color       : '橙',
            brand       : '',
            type        : 'PR',
            point       : 550,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すみっコぐらしチャンネル',
            id          : 'PCH4-90',
            rare        : 'R',
            name        : 'すみっコぐらしいっぱいスカート',
            imgUrl      : '/images/items/PCH4-90.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 500,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すみっコぐらしチャンネル',
            id          : 'PCH4-91',
            rare        : 'R',
            name        : 'すみっコぐらしにくきゅうシューズ',
            imgUrl      : '/images/items/PCH4-91.png',
            kind        : 'シューズ',
            color       : '橙',
            brand       : '',
            type        : 'PR',
            point       : 450,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すみっコぐらしチャンネル',
            id          : 'PCH4-92',
            rare        : 'R',
            name        : 'すみっコぐらしねこヘアアクセ',
            imgUrl      : '/images/items/PCH4-92.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 450,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'すみっコぐらしチャンネル',
            id          : 'PCH4-93',
            rare        : 'R',
            name        : 'すみっコぐらしにくきゅうピンクトップス',
            imgUrl      : '/images/items/PCH4-93.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 500,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すみっコぐらしチャンネル',
            id          : 'PCH4-94',
            rare        : 'R',
            name        : 'すみっコぐらしにくきゅうピンクシューズ',
            imgUrl      : '/images/items/PCH4-94.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 450,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すみっコぐらしチャンネル',
            rare        : 'R',
          }),
          item({
            collection  : 'すみっコぐらしチャンネル',
            rare        : 'R',
          }),


          item({
            collection  : 'すみっコぐらしチャンネル',
            id          : 'PCH4-82',
            rare        : 'R',
            name        : 'とんかつ＆えびふらいのしっぽ',
            imgUrl      : '/images/items/PCH4-82.png',
            kind        : 'パシャッとアイテム',
            color       : '茶',
            brand       : '',
            type        : 'PR',
            point       : 550,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すみっコぐらしチャンネル',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : 'すみっコぐらしチャンネル',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : 'すみっコぐらしチャンネル',
            kind        : 'パシャッとアイテム',
          }),
        ],
      }
    },

    computed: {
      itemsFiltered () {
        const { excepts, items } = this
        return excepts.length
          ? items.filter(item => !excepts.includes(item.collection) )
          : items
      },

      itemsMaJor () {
        const { major, itemsFiltered, itemsPasha } = this
        return itemsFiltered.filter(item => major.includes(item.collection) && !itemsPasha.includes(item))
      },

      itemsKR () {
        return _.where(this.itemsMaJor, { rare: 'KR' })
      },

      itemsPR () {
        return _.where(this.itemsMaJor, { rare: 'PR' })
      },

      itemsSR () {
        return _.where(this.itemsMaJor, { rare: 'SR' })
      },

      itemsR () {
        return _.where(this.itemsMaJor, { rare: 'R' })
      },

      itemsN () {
        return _.where(this.itemsMaJor, { rare: 'N' })
      },

      itemsPasha () {
        return _.where(this.itemsFiltered, { kind: 'パシャッとアイテム' }).filter(item => this.major.includes(item.collection) )
      },

      itemsNakayoshiChannel () {
        return _.where(this.itemsFiltered, { collection: 'なかよしチャンネル' })
      },

      itemsDWChannel () {
        return _.where(this.itemsFiltered, { collection: 'Dolly Waltz チャンネル' })
      },

      itemsRBChannel () {
        return _.where(this.itemsFiltered, { collection: 'Romance Beat チャンネル' })
      },

      itemsUQChannel () {
        return _.where(this.itemsFiltered, { collection: 'Universe Queen チャンネル' })
      },

      itemsMolly () {
        return _.where(this.itemsFiltered, { collection: 'モーリーファンタジー限定' })
      },

      itemsHalloween () {
        return _.where(this.itemsFiltered, { collection: 'ハロウィンコーデキャンペーン' })
      },

      itemsShinyFriendsSp () {
        return _.where(this.itemsFiltered, { collection: 'シャイニーフレンズスペシャル大会' })
      },

      itemsKirats () {
        return _.where(this.itemsFiltered, { collection: 'ミラクル☆キラッツセレクション' })
      },

      itemsKiratsPR () {
        return _.where(this.itemsKirats, { rare: 'PR' })
      },

      itemsKiratsSR () {
        return _.where(this.itemsKirats, { rare: 'SR' })
      },

      itemsKiratsR () {
        return _.where(this.itemsKirats, { rare: 'R' })
      },

      itemsSGChannel () {
        return _.where(this.itemsFiltered, { collection: 'すみっコぐらしチャンネル' })
      },
    },
  }
</script>


<template>
  <ItemPage :items="items" :narrowCols="[1]">

    <template #title>
      <PageChooser />
      <time>{{ date }}</time>
    </template>

    <template #col1>
      <ItemList title="KR ★★★★" color="#ff5d91" :items="itemsKR" />
    </template>

    <template #col2>
      <ItemList title="PR ★★★" color="#ffa1bc" :items="itemsPR" />
      <ItemList title="PR モーリー限定 ★★★" color="#55b272" :items="itemsMolly" />
      <ItemList title="SR ★★" color="#00c7da" :items="itemsSR" />
    </template>

    <template #col3>
      <ItemList title="R ★" color="#feab0d" :items="itemsR" />
      <ItemList title="N" color="#f6c3b2" :items="itemsN" />
    </template>

    <template #col4>
      <ItemList title="パシャッとアイテム" color="#c598ff" :items="itemsPasha" />
      <ItemList title="なかよしチャンネル" color="#c598ff" :items="itemsNakayoshiChannel" />
      <ItemList title="ブランドランク" color="#c598ff" :items="itemsBrandRank" />
      <ItemList title="Dolly Waltz チャンネル" color="#c598ff" :items="itemsDWChannel" />
      <ItemList title="Romance Beat チャンネル" color="#c598ff" :items="itemsRBChannel" />
      <ItemList title="Universe Queen チャンネル" color="#c598ff" :items="itemsUQChannel" />
    </template>

    <template #col5>
      <ItemList title="シャイニーフレンズスペシャル大会" color="#a1c0fa" :items="itemsShinyFriendsSp" />
      <ItemList title="ハロウィンコーデキャンペーン" color="#a1c0fa" :items="itemsHalloween" />
      <ItemList title="すみっコぐらしチャンネル" color="#a1c0fa" :items="itemsSGChannel" />
    </template>

    <template #col6>
      <ItemList title="キラッツセレクション PR" color="#ffa1bc" :items="itemsKiratsPR" />
      <ItemList title="キラッツセレクション SR" color="#00c7da" :items="itemsKiratsSR" />
      <ItemList title="キラッツセレクション R" color="#feab0d" :items="itemsKiratsR" />
      <Status :date="date" :items="items" :showKira="true" :showKR="true" />
    </template>

  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  // コレクショングループ間の間隔 (KR)
  .Page ::v-deep .Page__col:nth-child(1) .ItemList:nth-child(1) {
    .Item:nth-child(5),
    .Item:nth-child(6),
    .Item:nth-child(7),
    .Item:nth-child(8) {
      margin-top: $size-unit * 8;
    }
  }

  // コレクショングループ間の間隔 (PR)
  .Page ::v-deep .Page__col:nth-child(2) .ItemList:nth-child(1) {
    .Item:nth-child(9),
    .Item:nth-child(10),
    .Item:nth-child(11),
    .Item:nth-child(12) {
      margin-top: $size-unit * 8;
    }
  }

  // コレクショングループ間の間隔 (SR)
  .Page ::v-deep .Page__col:nth-child(2) .ItemList:nth-child(3) {
    .Item:nth-child(5),
    .Item:nth-child(6),
    .Item:nth-child(7),
    .Item:nth-child(8) {
      margin-top: $size-unit * 8;
    }
  }

  // コレクショングループ間の間隔 (パシャテム)
  .Page ::v-deep .Page__col:nth-child(4) .ItemList:nth-child(1) {
    .Item:nth-child(5),
    .Item:nth-child(6),
    .Item:nth-child(7),
    .Item:nth-child(8),
    .Item:nth-child(9),
    .Item:nth-child(10),
    .Item:nth-child(11),
    .Item:nth-child(12) {
      margin-top: $size-unit * 8;
    }
  }


  // PC View: ステータスの表示位置を調整
  .Page ::v-deep .Status {
    // PC View のとき position: absolute になっている (see: ItemPage.vue)
    bottom: 0;
    left: 0;
  }

  // PC View: ステータス表示を置く空間を確保
  // @include iroha-vw-range($from: strip-unit($device-width--pc), $also-apply: print) {
  //   .Page ::v-deep .Page__body {
  //     padding-bottom: $size-unit * 20;
  //   }
  // }
</style>
